module.exports = __webpack_public_path__ + "img/personnel_access_feature_02.d68307a4.jpg";